import {Injectable} from '@angular/core';
import {Actions, createEffect,  ofType} from '@ngrx/effects';
import { select, Store} from '@ngrx/store';
import {filter, map, switchMap, withLatestFrom} from 'rxjs/operators';
import {debug} from '../../../rxjs-operators';
import {Router} from '@angular/router';
import * as fromRoot from '../reducers';
import * as _ from 'lodash';
import {BaseEffect} from './base.effect';
import {error} from '..';
import {ArrayResponse, SendBackResult} from '..';
import {L10nTranslationService} from 'angular-l10n';
import {LoadServerURLAction, LoadServerURLFailAction, LoadServerURLSuccessAction, serverURLActionTypes} from '../actions/servers-url';
import {ServerForm, ServerFormUrl} from '../models/servers';
import {ServersService} from '../services/servers.service';

@Injectable()
export class ServerURLEffect extends BaseEffect {


  load$ = createEffect(() => {
    return this.actions$.pipe(ofType(serverURLActionTypes.LOAD),
      debug('ServerURL load action received.'),
      map((action: LoadServerURLAction) => action.payload),
      withLatestFrom(this.store.pipe(
        select(fromRoot.selectors.getCurrentClient),
        filter(client => !_.isEmpty(client))
      )),
      switchMap( ([action, client]) =>  this.serversService.getServersURL(client.uuid , action.server, action.serviceType).pipe(
        map((resp: SendBackResult<ArrayResponse<ServerFormUrl>>) =>
          resp.data.array.map(serverUrl => {
            // tslint:disable-next-line:radix
            return  {
              displayName: serverUrl.displayName,
              id: serverUrl.id,
              name: serverUrl.name,
              serverID: serverUrl.serverID,
              uuid: serverUrl.uuid,
              value: serverUrl.value}
          })),
      map((serverUrls: ServerFormUrl[]) =>  new LoadServerURLSuccessAction(serverUrls)))),
  )
  });


  loadFail$ = createEffect(() => { return this.actions$.pipe(ofType(serverURLActionTypes.LOAD_FAIL),
    debug('A server error occurred while retrieving ServerURL list.'),
    map((action: LoadServerURLFailAction) =>
      error(this.translation.translate('SERVER_LOAD_ERROR') + '  ' + action.payload, this.translation.translate('TOAST_ERROR_TITLE'))))
  });

  protected handleUnhandledError = (response) => {
    return new LoadServerURLFailAction(response['error'].message); }

  protected handleGoneError = (response) => {
    return new LoadServerURLFailAction(response['error'].message);
  }

  constructor(router: Router,
              private actions$: Actions,
              private store: Store<fromRoot.AppState>,
              private translation: L10nTranslationService,
              private serversService: ServersService) {
  super(router);
  }
}
